//环球影城
export const ubrTickerRouter = [
  {
    path: '/service/ubrTicketDirect/pro',
    name: 'UbrTicketPro',
    component: () => import('@/views/service/serviceProvider/ubrTicketDirect/UbrTicketPro'),
    meta: {
      title: '商品绑定',
      keepAlive: false
    }
  },
  {
    path: '/service/ubrTicketDirect/order',
    name: 'UbrTicketOrder',
    component: () => import('@/views/service/serviceProvider/ubrTicketDirect/UbrTicketOrder'),
    meta: {
      title: '订单直连',
      keepAlive: false
    }
  },
  {
    path: '/service/ubrTicketDirect/account',
    name: 'UbrAccount',
    component: () => import('@/views/service/serviceProvider/ubrTicketDirect/UbrAccount'),
    meta: {
      title: '关联账号',
      keepAlive: false
    }
  },
  {
    path: '/service/ubrTicketDirect/rules',
    name: 'UbrRules',
    component: () => import('@/views/service/serviceProvider/ubrTicketDirect/UbrRules'),
    meta: {
      title: '同步规则',
      keepAlive: false
    }
  }
]